import React from "react";
import { Svg } from "../componet/Orientation/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
      viewBox="0 0 36 36"
      awars="true"
    >
      <path
        fill="#A71B38"
        d="M11.432 18.906a2.639 2.639 0 100 5.277 2.639 2.639 0 000-5.277zm0 4.397a1.76 1.76 0 110-3.519 1.76 1.76 0 010 3.519zM21.105 25.941a2.198 2.198 0 100 4.396 2.198 2.198 0 000-4.396zm0 3.518a1.318 1.318 0 110-2.637 1.318 1.318 0 010 2.637z"
      ></path>
      <path
        fill="#A71B38"
        d="M30.505 11.027a.36.36 0 00-.167 0H11.872a.377.377 0 00-.168 0 .43.43 0 00-.272.405v4.397a.414.414 0 00.132.307l.519.528a13.673 13.673 0 01-5.338-.835.44.44 0 00-.59.44v5.451a12.214 12.214 0 004.046 9.058H8.794a2.198 2.198 0 00-2.155 1.758 2.198 2.198 0 00-2.242 2.198.44.44 0 00.44.44h13.19a.44.44 0 00.44-.44 2.198 2.198 0 00-2.199-2.198h-.044a2.198 2.198 0 00-2.154-1.759h-1.407a12.214 12.214 0 004.045-9.057v-.43l1.759 1.758v2.154a3.923 3.923 0 00-1.32 2.937 3.957 3.957 0 107.57-1.61 3.923 3.923 0 00-.974-1.327v-2.154l6.903-6.912a.413.413 0 00.131-.307v-4.397a.43.43 0 00-.272-.405zm-1.231.88l-.88.88h-14.58l-.878-.88h16.338zm-1.759 1.758l-.88.88H15.575l-.88-.88h12.821zm-15.204-1.17l3.518 3.474c-.238.08-.484.159-.73.22l-2.788-2.743v-.95zm0 2.2l1.759 1.758c-.276.053-.548.097-.818.132l-.88-.88-.06-1.01zm1.759 16.962a1.319 1.319 0 011.319 1.319.44.44 0 00.44.44h.44a1.32 1.32 0 011.24.879H5.355a1.32 1.32 0 011.24-.88h.44a.44.44 0 00.439-.44 1.319 1.319 0 011.319-1.318h5.276zm1.759-9.937a11.326 11.326 0 01-4.397 8.943 11.326 11.326 0 01-4.397-8.943v-4.836c2.863.897 5.931.897 8.794 0v4.836zm.624-6.331h9.303l-4.651 4.652-4.652-4.652zm4.836 7.035l-4.581-4.582v-.95l5.531 5.532h-.95zm1.574.879v1.32a3.948 3.948 0 00-3.517 0v-1.32h3.517zm-6.155-3.262v-.95l3.333 3.333h-.95l-2.383-2.383zm7.474 8.098a3.077 3.077 0 11-6.154 0 3.077 3.077 0 016.154 0zm5.716-12.495l-6.595 6.595-.44-.475 7.035-7.035v.915zm0-2.198l-7.694 7.659-.475-.475 8.17-8.134v.95z"
      ></path>
      <path
        fill="#A71B38"
        d="M11.872 25.062h-.88v.88h.88v-.88zM10.113 25.062h-.88v.88h.88v-.88zM13.63 25.062h-.88v.88h.88v-.88z"
      ></path>
      <g fill="#A71B38" opacity="0.25">
        <path
          d="M34.374 9.594a.756.756 0 00-.8.8v15.987a.757.757 0 01-.8.8h-4.951a.8.8 0 000 1.6h4.95a2.356 2.356 0 002.401-2.4V10.394a.757.757 0 00-.8-.8zM4.793 4.001a.8.8 0 11-.792-.8.791.791 0 01.792.8zM7.193 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM9.594 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM31.173 3.201H11.995a.757.757 0 00-.8.8.757.757 0 00.8.8h19.178a.756.756 0 00.8-.8.757.757 0 00-.8-.8z"
          opacity="0.25"
        ></path>
        <path
          d="M32.774 0H2.4a2.357 2.357 0 00-2.4 2.401v23.98a2.357 2.357 0 002.4 2.4h2.313a.8.8 0 100-1.6H2.4a.756.756 0 01-.8-.8V2.4a.756.756 0 01.8-.8h30.373a.756.756 0 01.8.8v3.992H4a.756.756 0 00-.8.8.756.756 0 00.8.8h30.373a.756.756 0 00.8-.8V2.401a2.357 2.357 0 00-2.4-2.4z"
          opacity="0.25"
        ></path>
      </g>
    </Svg>
  );
}

export default Icon;
